import { Route, Routes } from 'react-router-dom'
import { SiteFooter, SiteHeader } from './components/SiteChrome'
import { ChecklistPage } from './pages/ChecklistPage'
import { HomePage } from './pages/HomePage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ReportPage } from './pages/ReportPage'

export function App() {
  return (
    <>
      <a className="skip-link" href="#main">
        Naar de inhoud
      </a>
      <SiteHeader />

      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* `kenteken` rather than `report`: the old site's URLs were Dutch and people link to them. */}
        <Route path="/kenteken/:plate" element={<ReportPage />} />
        <Route path="/checklist" element={<ChecklistPage />} />
        <Route path="/checklist/:plate" element={<ChecklistPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <SiteFooter />
    </>
  )
}
